import { exactId } from "./exactId.mjs";
import { redirectTarget } from "./redirectTarget.mjs";
import { trailingSlash } from "./trailingSlash.mjs";
import { problemDetails } from "./problemDetails.mjs";
export const defaultSelectors = {
  exactId,
  trailingSlash,
  redirectTarget,
  problemDetails
};